export const CATALOG_PATH = {
    root: "/psychologists",
    anyFilter: `/psychologists/:filter`,
    anyPageFilter: `/psychologists/:filter/:page`,
    cityFilter: `/psychologists/:city/:filter`,
    anyPageCityFilter: `/psychologists/:city/:filter/:page`,
    anyPage: `/psychologists/:page`,
    online: "/consultation-psychologist-online",
    anyPageOnline: "/consultation-psychologist-online/:page",
} as const
